/**
 * Maps AI API HTTP status + body to i18n keys (shared Web + Mobile).
 * @param {number} status
 * @param {{ code?: string, reason?: string }} [data]
 * @returns {string} i18n key
 */
export function resolveAiChatErrorKey(status, data = {}) {
  const code = String(data?.code || data?.reason || "")
    .trim()
    .toLowerCase();

  if (code === "unauthorized" || status === 401) return "ai.error.unauthorized";
  if (code === "rate_limited" || status === 429) return "ai.error.rateLimited";

  if (
    code === "missing_openai_key" ||
    code === "config_error" ||
    code === "ai_provider_not_configured"
  ) {
    return "ai.error.configMissing";
  }

  if (code === "missing-supabase-anon-config") return "ai.error.configMissing";
  if (code === "missing-bearer-token" || code === "invalid-token")
    return "ai.error.unauthorized";

  if (
    code === "no-primary-tenant" ||
    code === "tenant-lookup-failed" ||
    code === "missing-auth-context" ||
    code === "tenant-attach-exception"
  ) {
    return "ai.error.tenantRequired";
  }

  if (
    code === "server_error" ||
    code === "auth-exception" ||
    code === "ai_route_crash" ||
    code === "ai_internal_error" ||
    code === "not_found" ||
    status === 500 ||
    status === 404
  ) {
    return "ai.error.serverError";
  }

  if (code === "ballmates_ki_not_enabled") return "ai.error.notEnabled";
  if (status === 403) return "ai.error.forbidden";

  if (
    code === "unreachable" ||
    code === "ai_unreachable" ||
    status === 0 ||
    status === 502 ||
    status === 503
  ) {
    return "ai.error.unreachable";
  }

  return "ai.error.generic";
}
